import React, {Fragment, useEffect, useState} from 'react';
import Tabs from 'react-responsive-tabs';
import FieldCustomization from "../LegacySettings/FieldCustomization";
import LegacyImport from "../LegacySettings/LegacyImport";
import LegacyAuditLog from "../LegacySettings/LegacyAuditLog";
import LegacyDistribution from "../LegacySettings/LegacyDistribution";
import {
    getAccessedFormsFromProfile,
    getAppType,
    removeLastChar
} from "../../../Common/Appcommon";
import LegacyEmailTemplates from "../LegacySettings/LegacyEmailTemplates";
import LegacyCallSettings from '../LegacySettings/LegacyCallSettings';
import SenderVerification from "./SenderEmailVerification"
import UserMobileSettings from './UserMobileSettings';

const Administration = props => {

    let [selectedTab,setSelectedTab] = useState(0);
    let [defaultSelectedTab,setDefaultSelectedTab] = useState(props.defaultSelectedTab);
    const tabInfo = {'fieldCustom' : 0, 'organization' : 1};
    let [modifiedTabs,setModifiedTabs] = useState([{}]);
    useEffect(() => {
        getProfileAccessedFormTabs();
        if( defaultSelectedTab !== undefined && tabInfo[defaultSelectedTab] !== undefined){
            setSelectedTab(tabInfo[defaultSelectedTab]);
        }
    },[])
    
    let tabsContent = [
        {
            title: 'Field Customization',
            content: <FieldCustomization />,
            name : 'field_custom',
            formname : 'table_33',
            appType : '0',
        },
        {
            title: 'Distribution Rules',
            content: <LegacyDistribution />,
            name : 'distribution_rules',
            formname : 'distributionrule',
            appType : '2',
        },
        {
            title: 'Sender Email Address',
            content: <SenderVerification/>,
            name : 'sender_email_address',
            formname : 'table_12',
            appType : '0',
        },
        {
            title: 'User Mobile Settings',
            content: <UserMobileSettings />,
            name : 'user_mobile_settings',
            formname : 'user_settings',
            appType : '0',
        },
        /* {
            title: 'Email Templates',
            content: <LegacyEmailTemplates />,
            name : 'email_templates',
            formname : 'table_23',
            appType : '2',
        },
        /*{
            title: 'Print Templates',
            content: <LegacyPrintTemplates />,
            name : 'print_templates',
            formname : 'table_13'
        },*/
        {
            title: 'Import Log',
            content: <LegacyImport />,
            name : 'import_log',
            formname : 'table_72',
            appType : '0',
        },
        {
            title: 'Audit Log',
            content: <LegacyAuditLog />,
            name : 'audit_log',
            formname : 'table_73',
            appType : '0',
        },
        /* {
            title: 'Call Log',
            content: <LegacyCallLog />,
            name : 'call_log',
            formname : 'table_37'
        },
        {
            title: 'Inbound Mails',
            content: <LegacyInbound />,
            name : 'inbound_mails',
            formname : 'table_59'
        }, */
    ];

    /*let modifiedTabs = tabsContent;
    tabsContent = [];
    let _featureList = getSessionValue("_featureList");
    //alert("Distribution: "+_featureList.charAt(DISTRIBUTION_RULE_INDEX));
    //alert("Cloud telephony: "+_featureList.charAt(CLOUD_TELEPHONEY_INDEX));
    modifiedTabs.map((tab, index) => {
        if(tab.name === "distribution_rules" && isFeatureEnabled(DISTRIBUTION_RULE_INDEX - 1)){
            tabsContent.push(tab);
        } else if (tab.name === "call_log" && isFeatureEnabled(CLOUD_TELEPHONEY_INDEX - 1)){
            tabsContent.push(tab);
        } else if (tab.name !== "distribution_rules" && tab.name !== "call_log"){
            tabsContent.push(tab);
        }
    })*/

    async function getProfileAccessedFormTabs() {
        let tabList = "";
        tabsContent.map((forms, index) => {
            tabList += forms['formname']+",";
        });
        tabList = removeLastChar(tabList);
        let responce = await  getAccessedFormsFromProfile(tabList);
        let curAppType = getAppType();
        if(responce.issuccess){
            let modifiedTab = [];
            let data = responce.data;
            data.map((forms, indexs) => {
                tabsContent.map((tab, index) => {
                    const filteredArray = modifiedTab.filter(obj => Object.values(obj).includes('user_settings'));
                    if((tab.formname === data[indexs] || (tab.formname === 'user_settings' && filteredArray.length === 0)) && (tab.appType === curAppType || tab.appType === "0")){
                        modifiedTab.push(tab);
                    }
                })
            })
            setModifiedTabs(modifiedTab);
        }
    }

    function getTabs() {
        return modifiedTabs.map((tab, index) => ({
            title: tab.title,
            getContent: () => tab.content,
            key: index,
        }));
    }

    return (
        <Fragment>
            <Tabs
                tabsWrapperClass="body-tabs body-tabs-layout header-tab-padding"
                transform={false}
                showInkBar={true}
                selectedTabKey={selectedTab}
                items={getTabs()}/>
        </Fragment>
    )

}

export default Administration;
